export default {
  LEADS_OVERVIEW: 'Présentation des prospects',
  TOTAL_LEADS: 'Nombre total de prospects',
  HOT_LEADS: 'Pistes chaudes',
  WARM_LEADS: 'Des pistes chaleureuses',
  COLD_LEADS: 'Des pistes froides',
  NO_RECORDS_FOUND: 'Aucun enregistrement trouvé',
  DETAILS: 'Détails',
  CATEGORY: 'Catégorie',
  SCAN_DATE_N_TIME: 'Date et heure de numérisation',
  FILTER: 'filtre',
  ALL: 'Tous',
  HOT: 'Chaud',
  WARM: 'Chaud',
  COLD: 'Froid',
  SELECT_DATES: 'sélectionner des dates',
  SEARCH_LEADS: 'pistes de recherche',
  SCANNED_BY: 'scanné par',
  FILES_INFO_SHARED: 'Fichiers et informations partagés',
  IMAGES: 'Images',
  NOTE: 'Note',
  DELETED_FILE_MSG: 'Ce fichier a été supprimé',
  LEAD_DETAILS: 'Détails du prospect',
  ANONYMISE_DAYS: 'Les détails des leads seront anonymisés dans {days} jours.'
}
